import React from 'react'

import { FormattedMessage } from 'react-intl'

import { ListActionsDialogBody, ListActionsDialogHeader } from '@components/dialogs'
import { Checkbox, FormControlLabel, InheritLink } from '@components/ui'

import LINKS from '@constants/links'

import type { ConsentViewProps } from './types'

export function NavM2MConsentView({ onAcceptedChange }: ConsentViewProps) {
  const [isAccepted, setAccepted] = React.useState(false)

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    setAccepted(event.target.checked)
    onAcceptedChange(event.target.checked)
  }

  return (
    <>
      <ListActionsDialogHeader
        borderless
        title={<FormattedMessage id="dialogs.companyConsent.navM2M.title" defaultMessage="Adatkezelési hozzájárulás" />}
      />
      <ListActionsDialogBody>
        <FormControlLabel
          checked={isAccepted}
          control={<Checkbox />}
          gap={8}
          label={
            <FormattedMessage
              id="dialogs.companyConsent.navM2M.checkboxLabel"
              defaultMessage="A funkció használatához elfogadom az <terms>ÁSZF</terms>-et és az <eula>adatvédelmi tájékoztató</eula>t."
              values={{
                eula: chunks => (
                  <InheritLink href={LINKS.navM2MEula} target="_blank" rel="noopener noreferrer">
                    {chunks}
                  </InheritLink>
                ),
                terms: chunks => (
                  <InheritLink href={LINKS.navM2MTerms} target="_blank" rel="noopener noreferrer">
                    {chunks}
                  </InheritLink>
                ),
              }}
            />
          }
          onChange={handleChange}
        />
      </ListActionsDialogBody>
    </>
  )
}
